import React, { useState } from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useHistory } from 'react-router-dom';

import { useStepControl } from './hooks';
import { StepsResolution886 } from '../../enums';
import ButtonDefault from '@/components/ui/ButtonDefault';
import { InitialVersion } from '../../components/Result/InitialVersion';
import { GeneralVersion } from '../../components/Result/GeneralVersion';
import { VersionButton } from '../../components/Result/InitialVersion/components';
import * as S from './styles';

export function ResultStep(): JSX.Element {
	const [selectedVersion, setSelectedVersion] = useState<string>('initial');

	const history = useHistory();
	const { reviewConsolidated, handleUpdateStep } = useStepControl();

	function handleOnVersionSelect(version: string): void {
		setSelectedVersion(version);
	}

	function handleOnClose(): void {
		const pathname = '/custom-reports/resolution-886';
		history.push({ pathname });
	}

	return (
		<Row justify="center" align="middle" gutter={[16, 16]}>
			<S.DefaultResultWrapper>
				<Row justify="space-between" align="top">
					<Col>
						<S.DefaultStepTitle>{I18n.get('Result')}</S.DefaultStepTitle>
					</Col>
					<Col>
						<VersionButton onVersionSelect={handleOnVersionSelect} />
					</Col>
				</Row>
				{selectedVersion === 'general' ? <GeneralVersion /> : <InitialVersion />}
			</S.DefaultResultWrapper>
			<Col>
				<Row gutter={[16, 16]}>
					{!reviewConsolidated && (
						<Col>
							<ButtonDefault
								type="default"
								onClick={() => handleUpdateStep(StepsResolution886.ACTION_PLAN)}
							>
								{I18n.get('Back')}
							</ButtonDefault>
						</Col>
					)}
					<Col>
						<ButtonDefault type="primary" onClick={handleOnClose}>
							{I18n.get('Close')}
						</ButtonDefault>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
